// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"505":"f14dddfc","687":"6c6af2f6","908":"fd8095bc"}[chunkId] + ".css";
};